import pataJpg from "../../../../images/pastajpg.jpg";
export const pastaData = [
  {
    name: "Angel Hair Pasta",
    image: pataJpg,
    price: "40.50",
    description: "chicken,BBQ sauce,tomato",
  },

  {
    name: "Bow Tie Pasta",
    image: pataJpg,
    price: "130.10",
    description: "beef patty, BBQ sauce,",
  },
  {
    name: "Bucatini Pasta",
    price: "150.30",
    deletedprice: ".200",
    description: "cheese,Naga",
  },
  {
    name: "Ditalini Pasta",
    image: pataJpg,
    price: "15.40",
    deletedprice: ".200",
    description: "cheese,Naga",
  },
  {
    name: "Gemelli Pasta",
    image: pataJpg,
    price: "15.50",
    deletedprice: ".20",
    description: "cheese,Naga",
  },
];
